export default __webpack_public_path__ + "static/media/subasta-logo.c9554761.svg";